import { useMemo } from "react";
import messages from "../i18n/messages";
import useLocale from "./useLocale";
function useTranslation() {
  const { locale } = useLocale();
  const t = useMemo(() => {
    return (key) => {
      const bundle = messages[locale] || messages.en;
      return bundle[key] || messages.en[key] || key;
    };
  }, [locale]);
  return { t, locale };
}
export {
  useTranslation as default
};
